import { Component, inject } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { TopbarComponent } from '../topbar/topbar.component'
import { RouterModule } from '@angular/router'
import { SidebarComponent } from '../sidebar/sidebar.component'
import { FooterComponent } from '../footer/footer.component'
import { getSidebarsize } from '@/app/store/layout/layout-selector'
import { changesidebarsize } from '@/app/store/layout/layout-action'
import { Store } from '@ngrx/store'

@Component({
  selector: 'app-vertical',
  standalone: true,
  imports: [TopbarComponent, RouterModule, SidebarComponent, FooterComponent],
  templateUrl: './vertical.component.html',
  styles: ``,
})
export class VerticalComponent {
  private store = inject(Store)
  private readonly mobileMediaQuery = window.matchMedia('(max-width: 1199.98px)')
  isMobileViewport = this.mobileMediaQuery.matches
  isSidebarOpen = true

  constructor() {
    this.store.dispatch(changesidebarsize({ size: 'default' }))
    this.mobileMediaQuery.addEventListener('change', this.onViewportChange)

    this.store.select(getSidebarsize).pipe(takeUntilDestroyed()).subscribe((size) => {
      document.body.setAttribute('data-sidenav-size', size)
    })
  }

  ngOnDestroy(): void {
    this.mobileMediaQuery.removeEventListener('change', this.onViewportChange)
  }

  onToggleMobileMenu(): void {
    if (!this.isMobileViewport) return

    if (this.isSidebarOpen) {
      this.closeSidebar()
    } else {
      this.openSidebar()
    }
  }

  closeSidebar(): void {
    if (!this.isMobileViewport) return

    this.isSidebarOpen = false
    this.store.dispatch(changesidebarsize({ size: 'collapsed' }))
  }

  openSidebar(): void {
    this.isSidebarOpen = true
    this.store.dispatch(changesidebarsize({ size: 'default' }))
  }

  private onViewportChange = (event: MediaQueryListEvent): void => {
    this.isMobileViewport = event.matches
    this.isSidebarOpen = true
    this.store.dispatch(changesidebarsize({ size: 'default' }))
  }
}
